export const departmentAdminMap = {
  nurse: "6",
  medical: "1",
  speechtherapy: "25",
  rescue: "8",
  ems: "8",
  medibeauty: "26",
  archi: "12",
  fire: "13",
  software: "15",
  cafe: "10",
  tour: "4",
  chef: "9",
  society: "2",
  infant: "3",
  cybersecurity: "27",
  army: "5",
  game: "11",
  leports: "17",
  contents: "14",
  music: "18",
  art: "16",
  hairdesign: "28",
  taekwondo: "19",
  liberal: "24",
  freemajor: "24",
  beauty: "7",
  lifeart: "29",
  lifecare: "20",
  lifecontents: "23",
  lifeservice: "21",
  lifetech: "22",
};

export function getRestrictedDepartmentId(user) {
  if (!user) return null;

  if (user.departmentId) {
    return String(user.departmentId);
  }

  const userId = user.userId || user.id || user.loginId;
  if (!userId) return null;

  return departmentAdminMap[String(userId).toLowerCase()] || null;
}

export function isDepartmentRestricted(user) {
  return Boolean(getRestrictedDepartmentId(user));
}

export function getDepartmentAdminHome(user) {
  const departmentId = getRestrictedDepartmentId(user);
  return departmentId ? `/admin/department/${departmentId}/banner` : "/admin";
}
